module.exports = __webpack_public_path__ + "img/edit.cbdec5a7.svg";